// extracted by mini-css-extract-plugin
export default {"itemSpacing":"Subhero_itemSpacing__6AWlU"};